import { SB } from '@play-co/replicant';

export const native = SB.object({
  // native app last launched timestamp
  // If this is 0, player has never been on iOS
  appleLastLaunched: SB.int().min(0),
  googleLastLaunched: SB.int().min(0),

  // For TEST_APP_INSTALL_NUDGE_POPUP_VARIANT reward bucket we should give reward for success installation
  // idle - Reward was never given to user and user didn't saw promo popup
  // saw_promo - User saw promo and next state will be `received` reward
  // received - Waiting for claim UI on login
  // claimed - Player already claimed reward
  // rejected - Player installed app without promo so player never get reward for it
  appInstallRewardStatus: SB.tuple([
    'idle', //       idle => 'saw_promo' or 'rejected'
    'saw_promo', //  saw_promo => 'received'
    'received', //   received => 'claimed'
    'claimed', //    claimed => END
    'rejected', //   rejected => END
  ]).default('idle'),
});
